// Pestaña Alérgenos del presupuesto (formato nuevo): utilidades puras.
//
// Los 14 alérgenos oficiales con los IDs de producción (no existe alergeno-012)
// y el alta rápida: "3 × cacahuete", "3x cacahuete", "2 soja" crea N comensales
// numerados con ese alérgeno. Se entienden palabras con o sin tildes.

export const ALERGENOS_OFICIALES = [
  { id: 'alergeno-001', nombre: 'Gluten' },
  { id: 'alergeno-002', nombre: 'Lácteos' },
  { id: 'alergeno-003', nombre: 'Frutos secos' },
  { id: 'alergeno-004', nombre: 'Huevo' },
  { id: 'alergeno-005', nombre: 'Pescado' },
  { id: 'alergeno-006', nombre: 'Marisco' },
  { id: 'alergeno-007', nombre: 'Soja' },
  { id: 'alergeno-008', nombre: 'Sulfitos' },
  { id: 'alergeno-009', nombre: 'Apio' },
  { id: 'alergeno-010', nombre: 'Mostaza' },
  { id: 'alergeno-011', nombre: 'Sésamo' },
  { id: 'alergeno-013', nombre: 'Moluscos' },
  { id: 'alergeno-014', nombre: 'Altramuces' },
  { id: 'alergeno-cacahuetes', nombre: 'Cacahuetes' },
];

const IDS = ALERGENOS_OFICIALES.map(a => a.id);

// Palabras ya normalizadas (minúsculas, sin tildes) → ID oficial
const PALABRAS = {
  gluten: 'alergeno-001', trigo: 'alergeno-001', celiaco: 'alergeno-001', celiaca: 'alergeno-001', celiacos: 'alergeno-001',
  lacteos: 'alergeno-002', lacteo: 'alergeno-002', leche: 'alergeno-002', lactosa: 'alergeno-002', plv: 'alergeno-002',
  'frutos secos': 'alergeno-003', 'fruto seco': 'alergeno-003', 'frutos de cascara': 'alergeno-003', nueces: 'alergeno-003',
  huevo: 'alergeno-004', huevos: 'alergeno-004',
  pescado: 'alergeno-005', pescados: 'alergeno-005',
  marisco: 'alergeno-006', mariscos: 'alergeno-006', crustaceos: 'alergeno-006', crustaceo: 'alergeno-006',
  soja: 'alergeno-007', soya: 'alergeno-007',
  sulfitos: 'alergeno-008', sulfito: 'alergeno-008',
  apio: 'alergeno-009',
  mostaza: 'alergeno-010',
  sesamo: 'alergeno-011', 'granos de sesamo': 'alergeno-011',
  moluscos: 'alergeno-013', molusco: 'alergeno-013',
  altramuces: 'alergeno-014', altramuz: 'alergeno-014',
  cacahuetes: 'alergeno-cacahuetes', cacahuete: 'alergeno-cacahuetes', mani: 'alergeno-cacahuetes',
};

export const normalizarTexto = (texto) => String(texto || '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .replace(/[_-]+/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

// Palabra o código → ID oficial (null si no es uno de los 14)
export const alergenoDesdeTexto = (texto) => {
  if (!texto) return null;
  const crudo = String(texto).trim().toLowerCase();
  if (IDS.includes(crudo)) return crudo;
  let t = normalizarTexto(texto);
  if (t.startsWith('sin ')) t = t.slice(4).trim();
  if (t.startsWith('alergia a ') || t.startsWith('alergico a ') || t.startsWith('alergica a ')) {
    t = t.replace(/^alergi(a|co|ca) a /, '').trim();
  }
  if (t.startsWith('al ')) t = t.slice(3).trim();
  if (t.startsWith('a la ') || t.startsWith('a los ')) t = t.replace(/^a (la|los) /, '').trim();
  if (PALABRAS[t]) return PALABRAS[t];
  const oficial = ALERGENOS_OFICIALES.find(a => normalizarTexto(a.nombre) === t);
  if (oficial) return oficial.id;
  if (t.endsWith('s') && PALABRAS[t.slice(0, -1)]) return PALABRAS[t.slice(0, -1)];
  if (PALABRAS[`${t}s`]) return PALABRAS[`${t}s`];
  return null;
};

export const nombreAlergeno = (id, lista = ALERGENOS_OFICIALES) => (
  (lista.find(a => a.id === id) || ALERGENOS_OFICIALES.find(a => a.id === id) || {}).nombre || id
);

/**
 * Alta rápida. Entiende varias líneas (o separadas por ";"), cada una
 * "N × alérgeno[, alérgeno y alérgeno]" (también "Nx", "N x", "N por", "N").
 * Sin número, 1 comensal. Devuelve { grupos: [{ cantidad, alergenos_ids }], errores: [texto] }.
 */
export const interpretarAltaRapida = (texto) => {
  const grupos = [];
  const errores = [];
  String(texto || '')
    .split(/[\n;]+/)
    .map(l => l.trim())
    .filter(Boolean)
    .forEach((linea) => {
      const m = linea.match(/^(\d{1,3})\s*(?:[x×*]|por)?\s*(.*)$/i);
      let cantidad = 1;
      let resto = linea;
      if (m) {
        cantidad = parseInt(m[1], 10);
        resto = m[2];
      }
      const partes = resto
        .split(/\s*(?:,|\+|\/|\by\b|\be\b)\s*/i)
        .map(p => p.trim())
        .filter(Boolean);
      const ids = [];
      const desconocidos = [];
      partes.forEach((p) => {
        const id = alergenoDesdeTexto(p);
        if (id) {
          if (!ids.includes(id)) ids.push(id);
        } else {
          desconocidos.push(p);
        }
      });
      if (!cantidad || cantidad < 1 || cantidad > 200) {
        errores.push(`"${linea}": número de comensales no válido`);
      } else if (desconocidos.length > 0 || ids.length === 0) {
        errores.push(`"${linea}": no se reconoce ${desconocidos.length ? desconocidos.map(d => `"${d}"`).join(', ') : 'ningún alérgeno'}`);
      } else {
        grupos.push({ cantidad, alergenos_ids: IDS.filter(id => ids.includes(id)) });
      }
    });
  return { grupos, errores };
};

// Siguiente número libre para comensales numerados ("Persona 4", "Comensal 4", "4")
export const siguienteNumeroComensal = (comensales) => {
  let max = 0;
  (comensales || []).forEach((c) => {
    const m = String(c?.etiqueta || '').match(/^(?:(?:comensal|persona)\s*)?(\d+)$/i);
    if (m) max = Math.max(max, parseInt(m[1], 10));
  });
  return max + 1;
};

// Estado de la lista para mostrar ("recibida" = el cliente la ha dado por definitiva)
export const TEXTO_ESTADO_LISTA = {
  sin_lista: 'Pendiente',
  recibida: 'Lista definitiva',
  validada_cocina: 'Validada por cocina',
  sin_alergicos: 'Sin alérgicos',
};

// Dietas de la pestaña Alérgenos (se tienen en cuenta, sin garantía). Gemelas
// de `alergenos_utils.DIETAS`: la pestaña usa las que manda el GET y estas solo
// como respaldo.
export const DIETAS = [
  { id: 'vegetariano', nombre: 'Vegetariano' },
  { id: 'vegano', nombre: 'Vegano' },
  { id: 'sin_cerdo', nombre: 'Sin cerdo' },
  { id: 'embarazada', nombre: 'Embarazada' },
  { id: 'sin_lactosa', nombre: 'Sin lactosa' },
];

// Gemelo de `alergenos_utils.AVISO_EMBARAZADA` (el texto bueno llega en el GET)
export const AVISO_EMBARAZADA = 'Embarazada: las marcas del catálogo no están revisadas. Revisad con cocina todo el menú (quesos, embutidos, ahumados, crudos) antes de servirlo.';

export const nombreDieta = (id, lista = DIETAS) => (
  (lista.find(d => d.id === id) || DIETAS.find(d => d.id === id) || {}).nombre || id
);

// "Vegetariano", "Sin cerdo y sin lactosa"
export const textoDietas = (ids, lista = DIETAS) => {
  const nombres = (ids || []).map(id => nombreDieta(id, lista)).filter(Boolean);
  if (nombres.length === 0) return '';
  const textos = [nombres[0], ...nombres.slice(1).map(n => n.toLowerCase())];
  return textos.length === 1 ? textos[0] : `${textos.slice(0, -1).join(', ')} y ${textos[textos.length - 1]}`;
};

// Personas de un comensal (una fila puede ser un grupo sin nombres: "5 vegetarianos")
export const personasComensal = (c) => {
  const n = parseInt(c?.cantidad, 10);
  return Number.isFinite(n) && n > 1 ? n : 1;
};

// Colores de las casillas comensal × plato (diseño A+)
export const ESTILO_ESTADO_PLATO = {
  apto: { clase: 'bg-[#E3F3EC] text-[#0F5E43] border-[#B9E0CE]', texto: 'Apto' },
  contiene: { clase: 'bg-[#FDE8E6] text-[#8A1C12] border-[#F5C2BC]', texto: 'Contiene' },
  trazas: { clase: 'bg-[#FDF0DC] text-[#92400E] border-[#F3D19B]', texto: 'Trazas' },
  // No cumple una dieta (sin garantía): vegetariano, sin cerdo...
  dieta: { clase: 'bg-[#FFF1E6] text-[#9A3412] border-[#FDBA8C]', texto: 'Dieta' },
  sin_verificar: { clase: 'bg-[#EEF1EF] text-[#4A5A53] border-[#D5DCD8]', texto: 'Sin verificar' },
  // Plato sin verificar que cocina ha dado por bueno a mano para ese comensal
  confirmado_cocina: { clase: 'bg-[#E6EFF8] text-[#1E4E79] border-[#BCD4EC]', texto: 'Confirmado por cocina' },
};
